import { STATUS_STYLES } from '../Constants/statusStyles'

export default function StatusBadge({ status }) {
  const s = STATUS_STYLES[status] || {
    background: 'rgba(255,255,255,0.08)',
    color: 'rgba(255,255,255,0.4)',
    dot: 'rgba(255,255,255,0.4)',
    label: status,
  }

  return (
    <span style={{
      background: s.background,
      color: s.color,
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: '11px',
      fontWeight: 600,
      letterSpacing: '0.07em',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '5px',
      whiteSpace: 'nowrap',
    }}>
      <span style={{
        width: '5px', height: '5px', borderRadius: '50%',
        background: s.dot, display: 'inline-block', flexShrink: 0,
      }} />
      {s.label || status}
    </span>
  )
}
